import {
	STORE_UPDATED,
	COMPONENT_CONNECTED,
	COMPONENT_DISCONNECTED,
	COMPONENT_BOOTSTRAPPED,
	COMPONENT_PROPERTY_CHANGED,
	COMPONENT_RENDERED,
	COMPONENT_DOM_READY,
	SET_INITIAL_STATE,
	NOW_UI_EVENT,
	PROPERTIES_SET,
	DISPATCH_EVENT,
	COMPONENT_PROPERTY_UPDATE_REQUESTED,
	COMPONENT_RENDER_REQUESTED
} from '../../constants';

const internalActionTypes = [
	PROPERTIES_SET,
	DISPATCH_EVENT,
	STORE_UPDATED,
	COMPONENT_CONNECTED,
	COMPONENT_DISCONNECTED,
	COMPONENT_BOOTSTRAPPED,
	COMPONENT_PROPERTY_CHANGED,
	COMPONENT_RENDERED,
	COMPONENT_DOM_READY,
	SET_INITIAL_STATE,
	NOW_UI_EVENT,
	'SEISMIC_COMPONENT_ERROR_THROWN',
	COMPONENT_PROPERTY_UPDATE_REQUESTED,
	COMPONENT_RENDER_REQUESTED
];

// TODO: memoize
export function isInternalActionType(type, internal = false) {
	return internalActionTypes.includes(type) && !internal;
}
